/* eslint-disable no-console, no-undef */

import { register } from "register-service-worker";

if (process.env.NODE_ENV === "production") {
  register(`${process.env.BASE_URL}firebase-messaging-sw.js`, {
    ready() {
      console.log("App Ready");
    },
    registered(reg) {
      console.log("Service worker has been registered.");
      setInterval(
        () => {
          reg.update();
        },
        1000 * 60 * 60
      ); // e.g. hourly checks
      // ✅ Reload exactly once when the new SW takes control
      let refreshing = false;
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (refreshing) return;
        refreshing = true;
        window.location.reload();
      });
    },
    cached() {
      console.log("Content has been cached for offline use.");
    },
    updatefound() {
      console.log("New content is downloading.");
    },
    updated(reg) {
      console.log("New content is available; determining context...");
      const isInPWA =
        window.matchMedia("(display-mode: standalone)").matches ||
        window.navigator.standalone === true; // iOS

      if (!isInPWA && reg.waiting) {
        // Ask the waiting SW to activate now; controllerchange will fire
        reg.waiting.postMessage({ action: "skipWaiting" });
      } else if (isInPWA) {
        // Keep your current UX for standalone mode
        document.dispatchEvent(
          new CustomEvent("pwaUpdateAvailable", { detail: reg.waiting })
        );
      }
    },
    offline() {
      console.log(
        "No internet connection found. App is running in offline mode."
      );
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    },
  });
}
